<template>
  <div class="container">
    <div class="shop_top">
      <shop-top :subnav_show="false"></shop-top>
    </div>
    <div class="width_center_1200">
      <el-form ref="ruleForm" :model="params" :rules="rules">
        <div class="account-form">
          <div class="title">{{ lang.user_register }}</div>
          <el-form-item prop="phone">
            <div class="input-box">
              <div class="tit">{{ lang.phone }}</div>
              <div class="phone-code">
                <select v-model="params.phoneprefix">
                  <option value="853">853</option>
                  <option value="86">86</option>
                </select>
              </div>
              <el-input
                v-model="params.phone"
                type="text"
                :placeholder="lang.phone_tips"
                prop="email"
              />
            </div>
          </el-form-item>
          <el-form-item prop="code">
            <div class="input-box">
              <div class="tit">{{ lang.code }}</div>
              <el-input v-model="params.code" type="text" :placeholder="lang.code" />
              <div v-show="showCode" class="btn" @click="getCode()">{{ lang.get_code }}</div>
              <div v-show="!showCode" class="btn disabled">{{ lang.sent }}{{ count }}s</div>
            </div>
          </el-form-item>
          <el-form-item prop="loginpwd">
            <div class="input-box">
              <div class="tit">{{ lang.pwd }}</div>
              <el-input v-model="params.loginpwd" type="password" />
            </div>
          </el-form-item>
          <el-form-item prop="confirmPwd">
            <div class="input-box">
              <div class="tit">{{ lang.confirm_pwd }}</div>
              <el-input v-model="params.confirmPwd" type="password" />
            </div>
          </el-form-item>
          <div class="submit-btn" @click="handleReg('ruleForm')">{{ lang.protocol_text5 }}</div>
          <div class="tips">
            {{ lang.protocol_text1 }}
            <router-link to="/parse?key=loginuserkey">{{ lang.protocol_text2 }}</router-link>
            {{ lang.protocol_text3 }}
            <router-link to="/parse?key=loginuserPrivacykey">{{ lang.protocol_text4 }}</router-link>
          </div>
        </div>
      </el-form>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { sendmsg } from '@/api/home'
import { regbindinguid } from '@/api/login'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  computed: {
    lang() {
      return this.$t('register')
    },
    uid() {
      return this.$route.query.uid || ''
    }
  },
  data() {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register').pwd_confirm_tips))
      } else if (value !== this.params.loginpwd) {
        callback(new Error(this.$t('register').pwd_confirm_check_tips))
      } else {
        callback()
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register').pwd_tips))
      } else if (!this.$pdw_str.test(value)) {
        callback(new Error(this.$t('register').pwd_regular_tips))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register').phone_tips))
      } else if (
        !this.$macao_phone.test(value) &&
        !this.$phone_str.test(value)
      ) {
        callback(new Error(this.$t('register').phone_regular_tips))
      } else {
        callback()
      }
    }
    return {
      params: {
        phone: '',
        loginpwd: '',
        code: '',
        phoneprefix: '853',
        confirmPwd: ''
      },
      count: 60,
      timer: null,
      loading: false,
      showCode: true,
      rules: {
        phone: [{ validator: validatePhone, trigger: ['blur', 'change'] }],
        loginpwd: [{ validator: validatePwd, trigger: ['blur', 'change'] }],
        confirmPwd: [
          { validator: validateConfirmPwd, trigger: ['blur', 'change'] }
        ],
        code: [
          {
            required: true,
            message: this.$t('register').code_tips,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    handleReg(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          regbindinguid({
            phone: this.params.phone,
            loginpwd: this.params.loginpwd,
            phoneprefix: this.params.phoneprefix,
            code: this.params.code,
            uid: this.uid
          }).then((res) => {
            if (res.code === 1) {
              this.$confirm(this.lang.register_success_tips, this.lang.tips, {
                confirmButtonText: this.lang.confirm_text,
                cancelButtonText: this.lang.cancel_text,
                type: 'warning'
              }).then(() => {
                this.$router.push('/login')
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 获取验证吗
    async getCode() {
      if (!this.params.phone) {
        this.$message.error(this.lang.phone_tips)
        return
      }
      if (this.params.phoneprefix === '853') {
        if (!this.$macao_phone.test(this.params.phone)) {
          this.$message.error(this.lang.phone_regular_tips)
          return
        }
      } else {
        if (!this.$phone_str.test(this.params.phone)) {
          this.$message.error(this.lang.phone_regular_tips)
          return
        }
      }
      await sendmsg({
        phoneprefix: this.params.phoneprefix,
        phone: this.params.phone,
        tempcode: 'a1'
      })
      // 验证码倒计时
      if (!this.timer) {
        this.count = 60
        this.showCode = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--
          } else {
            this.showCode = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #fff;
}
.account-form {
  width: 330px;
  margin: 0 auto 50px;
  .title {
    text-align: center;
    font-size: 18px;
    color: #4f4f4f;
    padding: 40px 0;
  }
  .input-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 290px;
    height: 36px;
    background: #f1f4f9;
    border-radius: 4px;
    margin-bottom: 30px;
    padding: 0 15px;
    .tit {
      position: absolute;
      top: 0;
      left: -120px;
      text-align: right;
      width: 100px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      color: #333;
    }
    select {
      position: relative;
      background: #f1f4f9;
      border: 0;
      margin-right: 20px;
      outline: none;
    }
    input {
      flex: 1;
      background: #f1f4f9;
      border: 0;
      outline: none;
      font-size: 14px;
      line-height: 36px;
      margin-right: 20px;
    }
    .btn {
      position: absolute;
      top: 0;
      right: 20px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      cursor: pointer;
      color: #ec9221;
      &.disabled {
        color: #aaa;
      }
    }
  }
  .submit-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 320px;
    height: 38px;
    background: #ec9221;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    margin: 20px 0 50px;
  }
  .tips {
    font-size: 13px;
    color: #4f4f4f;
    a {
      color: #ec9221;
    }
  }
}
/deep/ .el-input__inner {
  padding: 0;
  background: transparent;
  border: 0;
}
/deep/ .el-form-item__error {
  top: 42px;
}
/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
</style>